import React from 'react';
import { useState, useEffect } from "react";
import CharacteristicModal from './../components/CharacteristicModal';
import FolderModal from './../components/FolderModal';
import DeleteModal from './../modal/delete/DeleteModal';
import ModalWrap from "./../modal/ModalWrap";
import Tree from './../components/Tree';

const CharacteristicsModule = ({ 
  handeleWrapClick,
  modalRef,
  modalRefHeader,
  showSecondTree,
  withCheckboxes,
  //openInfo,
  items,
  itemsTypes,
  addItem,
  deleteItem,
  updateItem,
  addItemInType,
  deleteItemFromType,
  selectedTypecode,
  updateItemType
}) => {

    //const [openInfo, setOpenInfo] = useState(false);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const closeModal = () => setModalIsOpen(false);

    const [currentCharacteristic, setCurrentCharacteristic] = useState({ name: '', type: '', libcode: 0 });
    const [characteristics, setCharacteristics] = useState([]);

    const [folderModalIsOpen, setFolderModalIsOpen] = useState(false);
    const closeFolderModal = () => setFolderModalIsOpen(false);

    const [standardValueModalIsOpen, setStandardValueModalIsOpen] = useState(false);
    const closeStandardValueModal = () => setStandardValueModalIsOpen(false);

    const [folders, setFolders] = useState([]);
    const [folderModalHeader, setFolderModalHeader] = useState('');

    const [selectedId, setSelectedId] = useState(null);
    const [selectedTypeId, setSelectedTypeId] = useState(null);
    const [selectedParent, setSelectedParent] = useState(null);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const [previousCharacteristic, setPreviousCharacteristic] = useState({ name: '', type: '', libcode: 0 });

    const [isCreateCharacteristic, setIsCreateCharacteristic] = useState(false);

    //const [items, setItems] = useState([]);
    //const [itemsTypes, setItemsTypes] = useState([]);
    const [selectedItems, setSelectedItems] = useState(new Set());

    const [standardValue, setStandardValue] = useState('');
    const [selectedParamType, setSelectedParamType] = useState(null);
    const [selectedLibcode, setSelectedLibcode] = useState(null);

    //const [withCheckboxes, setWithCheckboxes] = useState(false);
    //const [showSecondTree, setShowSecondTree] = useState(false)

    useEffect(() => {
      if (itemsTypes && itemsTypes.length) {
        const updatedSelectedItems = new Set();
        itemsTypes.forEach((item) => {
          updatedSelectedItems.add(item.id);
        });
        setSelectedItems(updatedSelectedItems);
      }
    }, [itemsTypes]);


    const openModal = (isAdd = false) => {
        //setCurrentCharacteristic(characteristic);
        setIsCreateCharacteristic(isAdd);
        if (isAdd) {
          setCurrentCharacteristic({ name: '', type: '', libcode: 0 });
        }
        else {
          setCurrentCharacteristic({ name: previousCharacteristic.name, type: previousCharacteristic.type, libcode: previousCharacteristic.libcode });
        }
        setModalIsOpen(true);
      };

      

    const handleCharacteristicSubmit = (characteristic) => {
      console.log(characteristic.libField);
        if (isCreateCharacteristic) {
          var sParent = 1;
          if (typeof selectedParent === 'number' && !isNaN(selectedParent)) {
            sParent = selectedParent;
          }
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertParamInLibrary`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({name: characteristic.name, parent: sParent, paramtype: characteristic.type, isFolder: 0, libcode: characteristic.libField, reportName: characteristic.name, isshown: 1})
            })
          .then(response => {
            response.json().then(async response => {
              console.log("characteristic was created, id = " + response.id);
              addItem(response.id, characteristic.name, sParent, characteristic.type, 0, characteristic.libField);
              setSelectedId(response.id);
            })
            
          })
          .catch(error => {
                  console.error('Ошибка добавления характеристики: ', error);
          });
        }
        else {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateParamInLibrary`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({id: selectedId, name: characteristic.name, paramtype: characteristic.type, isFolder: 0, libcode: characteristic.libField, reportName: characteristic.name, isshown: 1})
            })
          .then(response => {
            response.json().then(async response => {
              console.log("folder was updated, id = " + response.id);
              //addItem(response.id, folderName, selectedParent, -1, 1);
              updateItem(selectedId, { name: characteristic.name, paramtype: characteristic.type, libcode: characteristic.libField});
            })
              
            })
          .catch(error => {
                  console.error('Ошибка редактирования папки: ', error);
          });
        }
        setPreviousCharacteristic({ name: characteristic.name, type: characteristic.type.toString() , libcode: characteristic.libField});
      };

      const handleStandardValueSubmit = (standardValue) => {
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateLibObjParam`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({paramcode: selectedId, typecode: selectedTypecode, standardvalue: standardValue})
          })
        .then(response => {
          response.json().then(async response => {
            console.log("standardvalue was updated, id = " + response.id);
            updateItemType(selectedId, standardValue);
            //setStandardValue(standardValue);
          })
            
          })
        .catch(error => {
                console.error('Ошибка редактирования папки: ', error);
        });
      };

      const handleFolderSubmit = (folderName) => {
        if (isCreateCharacteristic) {
          var sParent = 1;
          if (typeof selectedParent === 'number' && !isNaN(selectedParent)) {
            sParent = selectedParent;
          }
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertParamInLibrary`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({name: folderName, parent: sParent, paramtype: -1, isFolder: 1, libcode: 0, reportName: folderName, isshown: 1})
            })
          .then(response => {
            response.json().then(async response => {
              console.log("folder was created, id = " + response.id);
              addItem(response.id, folderName, sParent, -1, 1, 0);
              setSelectedId(response.id);
              setSelectedParent(response.id);
            })
              
            })
          .catch(error => {
                  console.error('Ошибка создания папки: ', error);
          });
        }
        else {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateParamInLibrary`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({id: selectedId, name: folderName, paramtype: -1, isFolder: 1, libcode: 0, reportName: folderName, isshown: 1})
            })
          .then(response => {
            response.json().then(async response => {
              console.log("folder was updated, id = " + response.id);
              //addItem(response.id, folderName, selectedParent, -1, 1);
              //updateItem(selectedId, folderName);
              updateItem(selectedId, { name: folderName});
            })
              
            })
          .catch(error => {
                  console.error('Ошибка редактирования папки: ', error);
          });
        }
        setPreviousCharacteristic({ name: folderName, type: '-1', libcode: 0 });
      };

      const openStandardValueModal = (id) => {
         setStandardValueModalIsOpen(true);

         const itemType = getParamItemTypesById(id);
         if (itemType) {
            setStandardValue(itemType.standardvalue);
            setSelectedParamType(itemType.paramtype);
            setSelectedLibcode(itemType.libcode);
            console.log("itemType.libcode = " + itemType.libcode);
         }
         else {
          setStandardValue('');
          setSelectedParamType(null);
          setSelectedLibcode(null);
         }
      }

      const openFolderModal = (isCreate) => {
        setIsCreateCharacteristic(isCreate);
        if (isCreate) {
          setCurrentCharacteristic({ name: '', type: '', libcode: 0 });
          setFolderModalHeader('Создать папку');
        }
        else {
          setCurrentCharacteristic({ name: previousCharacteristic.name, type: previousCharacteristic.type, libcode: previousCharacteristic.libcode });
          setFolderModalHeader('Редактировать папку');
        }
         setFolderModalIsOpen(true);
      }

      const handleSelect = (item) => {
        console.log("item.libcode = " + item.libcode);
        const itemType = getParamItemTypesById(item.id);
        if (itemType) {
          setSelectedTypeId(item.id);
        }
        else {
          setSelectedTypeId(null);
        } 
        setPreviousCharacteristic({ name: item.name, type: item.paramtype.toString(), libcode: item.libcode });
        setSelectedId(item.id);
        if (item.isFolder == 0) {
          setSelectedParent(item.parent);
        }
        else {
          setSelectedParent(item.id);
        }
      };

      const openDeleteModal = () => {
        setIsDeleteModalOpen(true);
      };

      const handleDelete = () => {
        console.log("Элемент удалён");
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/deleteParamFromLibrary`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({id: selectedId})
          })
        .then(response => {
          console.log("characteristic deleted");
          deleteItem(selectedId);
          setSelectedId(null);
        })
        .catch(error => {
                console.error('Ошибка удаления характеристики: ', error);
        });
      };

      const getParamItemById = (id) => {
        return items.find(item => item.id === id);
      };

      const getParamItemTypesById = (id) => {
        return itemsTypes.find(item => item.id === id);
      };

      const addParamInType = (id) => {

        const item = getParamItemById(id);

        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertToLibObjParams`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({typecode: selectedTypecode, paramcode: id, standardvalue: ''})
          })
        .then(response => {
          response.json().then(async response => {
            addItemInType(id, item.name, id, id, item.typecode, item.paramtype, item.libcode);
          })
         })
        .catch(error => {
                console.error('Ошибка создания категории: ', error);
        });
      };

      const deletearamFromType = (id) => {

        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/deleteLibObjParam`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({paramcode: id, typecode: selectedTypecode})
          })
        .then(response => {
          response.json().then(async response => {
            deleteItemFromType(id);
            setSelectedTypeId(null);
          })
         })
        .catch(error => {
                console.error('Ошибка создания категории: ', error);
        });
      };

      const handleToggle = (id, isChecked) => {
        const updatedSelectedItems = new Set(selectedItems);
        if (isChecked) {
          updatedSelectedItems.add(id);
          addParamInType(id);
        } else {
          updatedSelectedItems.delete(id);
          deletearamFromType(id);
        }
        setSelectedItems(updatedSelectedItems);
      };

  return (
    <>
      {(
        <div>
      <CharacteristicModal isOpen={modalIsOpen} onClose={closeModal} onSubmit={handleCharacteristicSubmit} initialName={currentCharacteristic.name}
        initialType={currentCharacteristic.type} initialLibcode={currentCharacteristic.libcode}/>
      {/*<ul>
        {characteristics.map((char, index) => (
          <li key={index}>{char.name} ({char.type})</li>
        ))}
      </ul>*/}

      <FolderModal
        isOpen={folderModalIsOpen}
        onClose={closeFolderModal}
        onSubmit={handleFolderSubmit}
        initialName={currentCharacteristic.name}
        headerText={folderModalHeader}
      />

      <FolderModal
        isOpen={standardValueModalIsOpen}
        onClose={closeStandardValueModal}
        onSubmit={handleStandardValueSubmit}
        initialName={standardValue}
        headerText='Стандартное значение характеристики'
        paramtype={selectedParamType}
        libcode={selectedLibcode}
      />
      <ul>
        {folders.map((folder, index) => (
          <li key={index}>{folder}</li>
        ))}
      </ul>
    </div>
      )}
      
        <div className="tools__wrap" onClick={handeleWrapClick}>
<div ref={modalRefHeader} className="content-container">

{!withCheckboxes ? (
<div className="button-row">
          <div
              className="tool__add__new_info add__buttons"
              onClick={openFolderModal/*add__tool_new*/}
            >
              Создать папку
            </div>
            <div
              className="tool__add__new_info add__buttons"
              onClick={() => openModal(true)/*add__tool_new*/}
            >
              Добавить
            </div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedId ? 'disabled' : ''}`}
  onClick={() => {
    if (selectedId) {
      if (previousCharacteristic.type == -1) {
        openFolderModal(false);  // Ваше действие на удаление
      }
      else {
        openModal(false);  // Ваше действие на удаление
      }
    }
  }}
  style={{ 
    cursor: !selectedId ? 'not-allowed' : 'pointer',
    opacity: !selectedId ? 0.5 : 1,
  }}
>
  Редактировать
</div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedId || selectedId == 1 ? 'disabled' : ''}`}
  onClick={() => {
    if (selectedId) {
      openDeleteModal();  // Ваше действие на удаление
    }
  }}
  style={{ 
    cursor: !selectedId || selectedId == 1 ? 'not-allowed' : 'pointer',
    opacity: !selectedId || selectedId == 1 ? 0.5 : 1,
  }}
>
  Удалить
</div>
<div
  className={`tool__add__new_info add__buttons`}
  onClick={handeleWrapClick}
  id='closeWrap'
>
  Закрыть
</div>
</div>) : (
  <div className="button-row">
  <div
      className={`tool__add__new_info add__buttons ${!selectedTypeId ? 'disabled' : ''}`}
      onClick={() => openStandardValueModal(selectedTypeId)}
      style={{ 
        cursor: !selectedTypeId ? 'not-allowed' : 'pointer',
        opacity: !selectedTypeId ? 0.5 : 1,
      }}
    >
      Редактировать стандартное значение
    </div>
    </div>
)
}
            </div>


          <div ref={modalRef} className="tool__list__characteristics">
          
            {
           <div className="tree-container">
            <div className="tree">
              <Tree items={items} selectedId={selectedId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelect} withCheckboxes={withCheckboxes} />
            </div>
            {showSecondTree && (
            <div className="tree">
              <Tree items={itemsTypes} selectedId={selectedTypeId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelect} withCheckboxes={withCheckboxes} />
            </div>)}
            </div>}
            
          </div>
        </div>
      
      {isDeleteModalOpen && (
        <ModalWrap><DeleteModal
          set={setIsDeleteModalOpen}
          handeleDelete={handleDelete}
          question="Вы уверены, что хотите удалить этот элемент?"
        /></ModalWrap>
      )}
    </>
  );
};

export default CharacteristicsModule;